import { render } from "./DataVisual.vue?vue&type=template&id=2259da4f"
import script from "./DataVisual.vue?vue&type=script&lang=js"
export * from "./DataVisual.vue?vue&type=script&lang=js"

import "./DataVisual.vue?vue&type=style&index=0&id=2259da4f&lang=scss"

import exportComponent from "C:\\Users\\cheew\\OneDrive\\Desktop\\CE4172\\drum\\drum-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__